
import React from 'react';
import LocalizedText from '../../../presentational/LocalizedText';
import "./SurveyProgressIndicator.css";
import { SurveyDefinition, SurveyStepDefinition } from '../../../../types/Survey';
import { getProgressIndicatorType } from '../../Util/surveyStyles';

export interface SurveyProgressIndicatorProps {
    surveyDefinition: SurveyDefinition;
    stepDefinition: SurveyStepDefinition;
}

export default function (props: SurveyProgressIndicatorProps) {
    let progressIndicatorType = getProgressIndicatorType(props.surveyDefinition, props.stepDefinition);
    if (progressIndicatorType == "None" || props.stepDefinition.type == "VisualConsentStep" || props.stepDefinition.type == "ConsentReviewStep") { return; }

    let displayStepIndex = function () {
        var steps = props.surveyDefinition.steps.filter(s => !s.excludeFromProgressCalculation);
        return steps.findIndex(s => s.identifier === props.stepDefinition.identifier) + 1;
    }

    let totalStepCount = function () {
        return props.surveyDefinition.steps.filter(s => !s.excludeFromProgressCalculation).length;
    }

    let progressBarWidth = function () {
        var displayIndex = displayStepIndex();
        var displayTotal = totalStepCount();
        if (props.surveyDefinition.progressBarProgression == 'FastToSlow') {
            var index = Math.log(displayIndex + 1);
            var totalSteps = Math.log(displayTotal + 1);
            return (index / totalSteps) * 100;
        } else {
            return (displayIndex / displayTotal) * 100;
        }
    }

    let progressBarColor = { ...props.surveyDefinition.styles, ...props.stepDefinition.styles }.progressBarColor;

    return <div className="survey-progress-indicator">
        {progressIndicatorType == 'Text' &&
            <div className="step-counter">
                <LocalizedText textKey="step-of-label" values={{ currentStepNumber: `${displayStepIndex()}`, totalStepCount: `${totalStepCount()}` }} />
            </div>
        }
        {progressIndicatorType == 'Bar' &&
            <div className="progress-bar">
                <div className="progress-bar-background">
                    <div className="progress-bar-bar"
                        style={{
                            backgroundColor: progressBarColor,
                            width: `${progressBarWidth()}%`
                        }}>
                    </div>
                </div>
            </div>
        }
    </div>
}